/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Nothing_To_DoInputs */

const cs_ebr_nothing_to_do = /** @type {(inputs: Ebr_Nothing_To_DoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vše je aktuální — není co importovat.`)
};

const en_ebr_nothing_to_do = /** @type {(inputs: Ebr_Nothing_To_DoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything is up to date — nothing to import.`)
};

/**
* | output |
* | --- |
* | "Everything is up to date — nothing to import." |
*
* @param {Ebr_Nothing_To_DoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_nothing_to_do = /** @type {((inputs?: Ebr_Nothing_To_DoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Nothing_To_DoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_nothing_to_do(inputs)
	return cs_ebr_nothing_to_do(inputs)
});